import Vue from 'vue'
import Router from 'vue-router'

import auth from '../middleware/auth';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const Welcome = () => import('@/pages/inicio/Welcome')

const ApontamentoHoras = () => import('@/pages/apontamento-horas/lancamento/Index')
const HistoricoHoras = () => import('@/pages/apontamento-horas/historico/Historico')

const SincronizarProjetos = () => import('@/pages/sincronizar-projetos/Index')
const EditarProjetos = () => import('@/pages/sincronizar-projetos/Editar')

const ParametrizarCompetencia = () => import('@/pages/parametrizar-competencia/Index')
const BloquearCompetencia = () => import('@/pages/bloquear-competencia/Index')
const FechamentoCompetencia = () => import('@/pages/fechamento-competencia/Index')
const FaturamentoCompetencia = () => import('@/pages/faturamento-competencia/Index')
const FaturamentoFuncional = () => import('@/pages/faturamento-funcional/Index')
const FaturamentoAms = () => import('@/pages/faturamento-ams/Index')
const FaturamentoDesenvolvedores = () => import('@/pages/faturamento-desenvolvedores/Index')
const HorasFabricaDevs = () => import('@/pages/horas-fabrica-devs/Index')

const OrcamentoCompetencia = () => import('@/pages/orcamento/Index')
const AlocacaoHoras = () => import('@/pages/alocacao-horas/Index')

const PrioridadeAnalistas = () => import('@/pages/prioridade-analistas/Index')

const ListarUsuarios = () => import('@/pages/usuarios/Index')
const EditarUsuarios = () => import('@/pages/usuarios/Editar')
const LiberacaoHorasEPS = () => import('@/pages/liberacao-horas/Index')
const Projetos = () => import('@/pages/projetos/Index')

const Login = () => import('@/pages/login/Login')
const NotFound = () => import('@/pages/not-found/NotFound')

const OrcamentoAnalistas = () => import('@/pages/orcamento-analistas/Index')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        rule: 'isUnlogged',
      }
    },
    {
      path: '',
      name: '',
      component: DefaultContainer,
      children: [
        {
          path: '/',
          name: 'Início',
          component: Welcome,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: 'horas/apontamento',
          name: 'Apontamento de Horas',
          component: ApontamentoHoras,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: 'horas/historico',
          name: 'Histórico de Apontamentos',
          component: HistoricoHoras,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: 'horas/historico/:id',
          name: 'Histórico de Apontamentos Admin',
          component: HistoricoHoras,
          meta: {
            middleware: [auth],
            rule: 'isGestor',
          },
        },
        {
          path: '/projetos/sincronizar',
          name: 'Sincronizar Projetos',
          component: SincronizarProjetos,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/projetos/sincronizar/:id',
          name: 'Editar Sincronização de Projetos',
          component: EditarProjetos,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/parametrizar',
          name: 'Parametrização de Competências',
          component: ParametrizarCompetencia,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/bloquear',
          name: 'Bloquear Competência',
          component: BloquearCompetencia,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/fechamento',
          name: 'Fechamento de Competência',
          component: FechamentoCompetencia,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/faturamento',
          name: 'Faturamento de Competência',
          component: FaturamentoCompetencia,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/faturamento-funcional',
          name: 'Faturamento Funcional',
          component: FaturamentoFuncional,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
                {
          path: '/competencia/faturamento-ams',
          name: 'Faturamento AMS',
          component: FaturamentoAms,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/faturamento-desenvolvedores',
          name: 'Melhorias por Desenvolvedores',
          component: FaturamentoDesenvolvedores,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/horas-fabrica-devs',
          name: 'Horas Fábrica Devs',
          component: HorasFabricaDevs,
          meta: {
            middleware: [auth],
            rule: 'isAdmin',
          },
        },
        {
          path: '/competencia/orcamento',
          name: 'Orçamento de Competência',
          component: OrcamentoCompetencia,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: '/horas/alocacao',
          name: 'Alocação de Horas',
          component: AlocacaoHoras,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: '/gestao/prioridades',
          name: 'Plano de Atividades',
          component: PrioridadeAnalistas,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: '/gestor/usuarios',
          name: 'Listar Usuários',
          component: ListarUsuarios,
          meta: {
            middleware: [auth],
            rule: 'isGestor',
          },
        },
        {
          path: '/gestor/usuarios/:id',
          name: 'Editar Usuário',
          component: EditarUsuarios,
          meta: {
            middleware: [auth],
            rule: 'isGestor',
          },
        },
        {
          path: '/gestor/liberacao',
          name: 'Liberação de Horas',
          component: LiberacaoHorasEPS,
          meta: {
            middleware: [auth],
            rule: 'isGestor',
          },
        },
        {
          path: '/gestor/projetos',
          name: 'Projetos',
          component: Projetos,
          meta: {
            middleware: [auth],
            rule: 'isGestor',
          },
        },
        {
          path: '/competencia/orcamento-analistas',
          name: 'Orçamento dos Analistas',
          component: OrcamentoAnalistas,
          meta: {
            middleware: [auth],
            rule: 'isUser',
          },
        },
        {
          path: '*',
          component: NotFound,
          meta: {
            rule: 'isUser',
          },
        },
      ]
    },
  ]
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
